import { i18n } from "app/i18n/i18n";
import { getPathname } from "lib/routing";
import { toArray } from "lib/utils";
import { parseDates } from "./parseDates";

export const getSort = (qs) => {
  const { sort } = qs;

  let res;
  if (!sort || sort === "Date_Desc") res = { publicationDate: { order: "desc" } };
  else if (sort === "Date_Asc") res = { publicationDate: { order: "asc" } };
  else if (sort === "ReadCount_Desc") res = { readCount: { order: "desc" } };
  else if (sort === "Pages_Asc") res = { pageCount: { order: "asc" } };
  else if (sort === "Pages_Desc") res = { pageCount: { order: "desc" } };
  else if (sort === "ReadCount_4h") res = { readCount_4hr: { order: "desc" } };
  else if (sort === "ReadCount_24h") res = { readCount_24hr: { order: "desc" } };
  else if (sort === "ReadCount_7d") res = { readCount_7d: { order: "desc" } };
  else if (sort === "ReadCount_30d") res = { readCount_30d: { order: "desc" } };
  else {
    // eslint-disable-next-line
    console.error("Unrecognised sort value", sort);
  }

  return res;
};

export const getFrom = (qs, sizePref) => {
  const pageFrom = qs.From;
  const pageSize = getSize(qs, sizePref);
  const recordsFrom = pageFrom ? (pageFrom - 1) * pageSize : 0;
  return recordsFrom;
};

export const getDates = (qs) => {
  const { Date = "", DateTo = "" } = qs;
  return parseDates(Date, DateTo);
};

export const getFeaturedDates = () => {
  const Date = "10 Days";
  const DateTo = "";
  return parseDates(Date, DateTo);
};

export const getQuery = (qs) => {
  const q = toArray(qs[""] || qs.q);
  const title = toArray(qs.title);
  return { q, title };
};

export const getSize = (qs, sizePref) => {
  const { size } = qs;
  return size || sizePref;
};

export const getAssetClass = () => getPathPart(1);
export const getRegion = (qs) => qs.regions || "All";
export const getSubCategories = (qs, lang = i18n.getLanguage()) => qs[`txSubCategories.${lang}`];
export const getFinalPathnameArray = () => {
  const pathname = getPathname();
  return pathname === "/SP__Credit" ? pathname.split("/") : pathname.replace("_", " ").split("/");
};
export const getPathPart = (index) => decodeURI(getFinalPathnameArray()?.[index]);
export const getActiveAssetClassFromUrl = () => {
  const rawPath = getFinalPathnameArray().pop();

  return decodeURI(rawPath);
};
